import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { ButtonAction } from '@omnea-app/frontend/components/layout/dialog/buttonAction'
import { isDefined } from 'utils/type-guard/isDefined'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  bodyTexts: (ReactNode | string)[]
  actions: (ButtonAction & { alignLeft?: boolean })[]
  children?: ReactNode
  disableAutoCloseOnConfirm?: boolean
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  bodyTexts,
  actions,
  children,
  disableAutoCloseOnConfirm,
}: Props) {
  const handleButtonClick = async (buttonAction: ButtonAction) => {
    if (buttonAction.action === 'confirm') {
      onConfirm()
      if (!disableAutoCloseOnConfirm) {
        onClose()
      }
      return
    }
    if (buttonAction.action === 'cancel') {
      onClose()
      return
    }
    buttonAction.action()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ marginTop: 4 }}>
        <Stack direction="column" spacing={4}>
          {bodyTexts.filter(isDefined).map((bodyText, index) => (
            <DialogContentText key={index}>
              <Typography variant="Body16pxRegular">{bodyText}</Typography>
            </DialogContentText>
          ))}
          {children && children}
        </Stack>
      </DialogContent>
      <DialogActions>
        {actions.map((action, index) => (
          <Button
            data-testid={action.dataTestId}
            key={index}
            variant={action.variant}
            color={action.color}
            onClick={() => handleButtonClick(action)}
            disabled={action.disabled}
            loading={action.loading}
            sx={{ ...(action.alignLeft ? { mr: 'auto' } : undefined) }}
          >
            {action.text}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  )
}
